import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorMessagePipe } from './error-message.pipe';
import { PassengerNumberReplacePipe } from './passenger-number.pipe';
import { ReplacePipe } from './replace.pipe';
import { SkymilesErrorMessagePipe } from './skymiles-message.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ReplacePipe,
    ErrorMessagePipe,
    SkymilesErrorMessagePipe,
    PassengerNumberReplacePipe
  ],
  exports: [
    ReplacePipe,
    ErrorMessagePipe,
    SkymilesErrorMessagePipe,
    PassengerNumberReplacePipe
  ]
})
export class ReplaceModule {}
